import { useApplicantHelpers } from "@Client/@Composables/application-standalone/pages/applicants/useApplicantHelpers";
import SectionTitle from "@Client/@Modules/application-standalone/components/helpers/section-title.vue";
import PageSectionGroupLayout from "@Client/@Modules/application-standalone/components/layout/page-section-group-layout.vue";
import { defineComponent, toRefs } from "@vue/composition-api";
import NotificationPopover from "@Shared/components/general/notification-popover.vue";
import { useSummaryHelpers } from "@Client/@Composables/application-standalone/pages/summary/useSummaryHelpers";
export default defineComponent({
  name: "SummarySectionLayout",
  components: {
    PageSectionGroupLayout,
    SectionTitle,
    NotificationPopover
  },
  props: {
    id: {
      type: String,
      required: true
    },
    sectionTitle: {
      type: String,
      required: true
    },
    hasMissingInformation: {
      type: Boolean,
      default: false
    },
    sectionVisibilityValues: {
      type: Object,
      default: () => ({
        mainApplicant: true,
        coApplicants: true
      })
    },
    showAllApplicants: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const {
      allApplicants,
      applicantNameFromIndex,
      isApplicantVisibleFromFillOut
    } = useApplicantHelpers();
    const {
      editButtonText,
      allowEdit
    } = useSummaryHelpers();
    const {
      id,
      sectionVisibilityValues
    } = toRefs(props);
    const isApplicantVisible = (applicantId, applicantIndex) => {
      const isSectionVisibleForApplicant = applicantIndex === 0 ? sectionVisibilityValues.value.mainApplicant : sectionVisibilityValues.value.coApplicants;
      return isSectionVisibleForApplicant && isApplicantVisibleFromFillOut(applicantId);
    };
    return {
      allApplicants,
      applicantNameFromIndex,
      tooltipTargetId: `titleTooltipTarget-${id.value}`,
      isApplicantVisible,
      editButtonText,
      allowEdit
    };
  }
});